export default "__VITE_ASSET__BeK1_Kqr__"